import { GlobalToken } from 'antd';
import { AliasToken } from 'antd/lib/theme/internal';

type CustomThemeToken = Partial<AliasToken> & {
  genericContainerBg: string;
  containerCardBg: string;
  primaryButtonRoundedBg: string;
  placeholderVectorColor: string;
  actionIconColor: string;
  tabSolidBorderColor: string;
};

export type CustomGlobalThemeToken = GlobalToken & CustomThemeToken;

const lightThemeToken: CustomThemeToken = {
  borderRadius: 0,
  colorWarningBg: '#FFFCF4',
  boxShadow: '5px 5px 10px gray',
  boxShadowSecondary: '2px 3px 8px 0px #aaaaaa',
  colorText: '#000000',

  colorBgBase: '#ffffff',
  colorPrimaryBg: '#e6d8d8',

  colorTextSecondary: '#89909a',
  colorBgLayout: '#f7f7f7',
  colorPrimary: '#a6192e',
  colorLink: '#ac1b2c',
  colorHighlight: '#d5213a',
  colorBgSolidActive: '#7e0f1f',
  colorBgSolidHover: '#fedadf',
  colorBgSolid: '#eca9b2',
  colorBorderSecondary: '#f0f0f0',
  colorBorder: '#e1e1e1',
  colorBorderBg: '#e1e1e1',

  genericContainerBg: '#f4f4f4',
  containerCardBg: '#ffffff',
  primaryButtonRoundedBg: '#ef4444',
  placeholderVectorColor: '#e0e0e0',
  actionIconColor: '#868686',
  tabSolidBorderColor: '#d4d4d4',
};

const darkThemeToken: CustomThemeToken = {
  borderRadius: 0,
  colorWarningBg: '#FFFCF4',
  boxShadow: '0 0 0 black',
  boxShadowSecondary: '2px 3px 8px 0px #474747',
  colorText: '#ffffff',

  colorBgBase: '#1c1c1c',
  colorPrimaryBg: '#252525',

  colorBgContainer: '#1c1c1c',
  colorBgElevated: '#1c1c1c',
  colorTextSecondary: '#fcfcfc',
  colorBgLayout: '#141414',
  colorPrimary: '#ec344f',
  colorLink: '#ff5670',
  colorHighlight: '#d5213a',
  colorBgSolidActive: '#7e0f1f',
  colorBgSolid: '#3e3e3e',
  colorBgSolidHover: '#323232',
  colorBorder: '#545454',
  colorBorderBg: '#2e2e2e',

  genericContainerBg: '#141414',
  containerCardBg: '#1c1c1c',
  primaryButtonRoundedBg: '#cc2f46',
  placeholderVectorColor: '#3b3b3b',
  actionIconColor: '#868686',
  tabSolidBorderColor: '#545454',
};

export enum Theme {
  Dark = 'Dark',
  Light = 'Light',
}

export enum ThemeSelection {
  Dark = 'Dark',
  Light = 'Light',
  Auto = 'Auto',
}

export const themeTokens: Record<Theme, Partial<AliasToken>> = {
  Dark: darkThemeToken,
  Light: lightThemeToken,
};
